import { SupportedLanguage } from '../../config/constants/supportedLanguage.enum';
import { CountriesAction, CountriesActionType } from './countriesActionType';
import { ICountriesState } from './countriesState';

export function countriesReducer(
    state: ICountriesState = {
        countriesMap: {
            [SupportedLanguage.DE_DE]: {},
            [SupportedLanguage.EN]: {},
            [SupportedLanguage.EN_UK]: {},
            [SupportedLanguage.ES_ES]: {},
            [SupportedLanguage.JA]: {},
            [SupportedLanguage.ZH_TW]: {},
            [SupportedLanguage.ZH_CN]: {},
            [SupportedLanguage.UK_UA]: {},
            [SupportedLanguage.ID]: {},
            [SupportedLanguage.ZH_HK]: {},
            [SupportedLanguage.TH]: {},
            [SupportedLanguage.KO]: {},
            [SupportedLanguage.VI]: {},
        },
        loading: false,
    },
    countriesAction: CountriesAction,
) {
    switch (countriesAction.type) {
        case CountriesActionType.GET_COUNTRIES_REQUEST:
            return {
                loading: true,
            };
        case CountriesActionType.GET_COUNTRIES_FAILURE:
            return {
                loading: false,
            };
        case CountriesActionType.GET_COUNTRIES_SUCCESS:
            return {
                countriesMap: {
                    ...state.countriesMap,
                    [countriesAction.payload.lang]: countriesAction.payload.countries,
                },
                loading: false,
            };
        default:
            return state;
    }
}
